import React, { useState, useEffect } from 'react';
import './TinhTrangCapThiet.css';

const TinhTrangCapThiet = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 15,
    seconds: 30
  });

  const [spotsLeft, setSpotsLeft] = useState(50);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let { hours, minutes, seconds } = prev;
        
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }

        return { hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="urgency">
      <div className="container">
        <div className="urgency-content">
          <div className="urgency-card countdown-card">
            <div className="urgency-icon">⏰</div>
            <h3 className="urgency-title">Thời Gian Còn Lại</h3>
            <p className="urgency-subtitle">Chỉ còn thời gian để quay số hôm nay!</p>
            <div className="countdown">
              <div className="countdown-item">
                <div className="countdown-value">{String(timeLeft.hours).padStart(2, '0')}</div>
                <div className="countdown-label">Giờ</div>
              </div>
              <div className="countdown-separator">:</div>
              <div className="countdown-item">
                <div className="countdown-value">{String(timeLeft.minutes).padStart(2, '0')}</div>
                <div className="countdown-label">Phút</div>
              </div>
              <div className="countdown-separator">:</div>
              <div className="countdown-item">
                <div className="countdown-value">{String(timeLeft.seconds).padStart(2, '0')}</div>
                <div className="countdown-label">Giây</div>
              </div>
            </div>
          </div>

          <div className="urgency-card spots-card">
            <div className="urgency-icon">🎯</div>
            <h3 className="urgency-title">Lượt Quay Còn Lại</h3>
            <p className="urgency-subtitle">Chỉ còn lượt quay miễn phí hôm nay!</p>
            <div className="spots-left">
              <div className="spots-number">{spotsLeft}</div>
              <div className="spots-label">lượt quay</div>
            </div>
            <div className="spots-bar">
              <div className="spots-bar-fill" style={{ width: `${(spotsLeft / 100) * 100}%` }}></div>
            </div>
          </div>

          <div className="urgency-card daily-limit-card">
            <div className="urgency-icon">⭐</div>
            <h3 className="urgency-title">Giới Hạn Hàng Ngày</h3>
            <p className="urgency-subtitle">Mỗi ngày chỉ có người may mắn!</p>
            <div className="daily-limit">
              <div className="limit-number">1,000</div>
              <div className="limit-label">người may mắn</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TinhTrangCapThiet;

